"use client";

import type { LocalizationParamsFor, LocalizationType } from "@/Helpers";
import { useT } from "@/Hooks";

type TranslatedTextProps<K extends LocalizationType> = {
  i18nKey: K;
  fallback: string;
} & (undefined extends LocalizationParamsFor<K>
  ? { params?: LocalizationParamsFor<K> }
  : { params: LocalizationParamsFor<K> });

const TranslatedText = <K extends LocalizationType>({
  i18nKey,
  fallback,
  params,
}: TranslatedTextProps<K>) => {
  const t = useT();

  return <>{t(i18nKey, params as LocalizationParamsFor<K>, fallback)}</>;
};

export default TranslatedText;
